import getTimeIntervalString from '../../../lib/getTimeIntervalString';

export const jobIntervalMap = {
  'No Interval': null,
  // 'Every Minute': 1000 * 60,
  'Every 5 Minutes': 1000 * 60 * 5,
  'Every 10 Minutes': 1000 * 60 * 10,
  'Every 15 Minutes': 1000 * 60 * 15,
  'Every 20 Minutes': 1000 * 60 * 20,
  'Every 25 Minutes': 1000 * 60 * 25,
  'Every 30 Minutes': 1000 * 60 * 30,
  'Every 35 Minutes': 1000 * 60 * 35,
  'Every 40 Minutes': 1000 * 60 * 40,
  'Every 45 Minutes': 1000 * 60 * 45,
  'Every 50 Minutes': 1000 * 60 * 50,
  'Every 55 Minutes': 1000 * 60 * 55,
  'Every Hour': 1000 * 60 * 60,
  'Every 1.5 Hours': 1000 * 60 * 90,
  'Every 2 Hours': 1000 * 60 * 60 * 2,
  'Every 3 Hours': 1000 * 60 * 60 * 3,
  'Every 6 Hours': 1000 * 60 * 60 * 6,
  'Every 12 Hours': 1000 * 60 * 60 * 12,
  'Every Day': 1000 * 60 * 60 * 24,
  'Every 2 Days': 1000 * 60 * 60 * 24 * 2,
  'Every 3 Days': 1000 * 60 * 60 * 24 * 3,
  'Every Week': 1000 * 60 * 60 * 24 * 7,
  'Every 2 Weeks': 1000 * 60 * 60 * 24 * 14,
  'Every Month': 1000 * 60 * 60 * 24 * 30
};
export const inverseJobIntervalMap = Object.fromEntries(Object.entries(jobIntervalMap).map(([key, value]) => [value, key]));

export const formatJobInterval = (interval) => {
  if (!interval) {
    return 'No Interval';
  }
  return getTimeIntervalString(interval);
};
